import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { TipsAndUpdatesIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

type TaskTipProps = Readonly<{
	reasoning: string;
}>;

export const TaskTip: React.FC<TaskTipProps> = ({ reasoning }) => {
	return (
		<div className="flex items-start gap-2" data-qa="dynamic-task-tip">
			<TipsAndUpdatesIcon size={19} className="text-typography-weak shrink-0" />
			<Text variant="body" size="small" className="min-w-0 flex-1" as="p">
				<Text variant="body" size="small" fontWeight="bold" as="span">
					<Translate value="corgi.petition.starter_dashboard_v2.dynamic_tasks.tip.label" />
				</Text>
				<Text variant="body" size="small" as="span">
					{reasoning}
				</Text>
			</Text>
		</div>
	);
};
